module.exports = __webpack_public_path__ + "img/banner_news.ca8d52d7.png";